import React, { memo, useState, useCallback } from 'react'
import './footer.css'
import { FaYoutube, FaFacebook, FaInstagram, FaLinkedin, FaWhatsapp, FaUniversity, FaCopy, FaCheck } from 'react-icons/fa';
import hotels from './client/HotelPages/hotelpageData.json';

const CopyButton = ({ text }) => {
    const [copied, setCopied] = useState(false);
    const handleCopy = useCallback(() => {
        navigator.clipboard.writeText(text).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    }, [text]);
    return (
        <button onClick={handleCopy} className="footer-copy-btn" title={`Copy ${text}`}>
            {copied ? <FaCheck style={{ color: '#4caf50' }} /> : <FaCopy />}
        </button>
    );
};

const Footer = memo(() => {
    return (
        <footer className="hotel-footer">
            <div className="container">
                <div className="row g-3">

                    <div className="col-md-3 col-sm-6">
                        <div className="footer-glass-panel">
                            <h2>Registered Office</h2>
                            <address>
                                <h6>Friends Hotel</h6>
                                <p>PAUL PLAZA, Bagnan College Road, Vill Khalore</p>
                                <p>P.S Bagnan, Howrah, West Bengal - 711303</p>
                                <p>Email:{' '}
                                    <a href="mailto:booking@friendshotel.in" className='text-hotel' target='_blank' rel="noreferrer">
                                        booking@friendshotel.in
                                    </a>
                                </p>
                                <p>Complaints &amp; Suggestions:{' '}
                                    <a href='https://api.whatsapp.com/send/?phone=918777209081' className='text-hotel' target='_blank' rel="noreferrer">
                                        <FaWhatsapp /> +91 8777209081
                                    </a>
                                </p>
                                <p>Booking:{' '}
                                    <a href='https://api.whatsapp.com/send/?phone=916289428163' className='text-hotel' target='_blank' rel="noreferrer">
                                        <FaWhatsapp /> +91 6289428163
                                    </a>
                                </p>
                            </address>
                        </div>
                    </div>

                    <div className="col-md-3 col-sm-6">
                        <div className="footer-glass-panel">
                            <h2>Contact Us</h2>
                            <address>
                                <h6>Sourav Infotech</h6>
                                <p>
                                    <a className='text-hotel' target='_blank' rel="noreferrer" href='https://www.google.com/maps/dir/22.590753,88.362179/Sourav+Infotech,+82D,+Dani+Ghosh+Sarani+Road,+Garanhatta,+Beniatola,+Kolkata,+West+Bengal+700006,+India/@22.5907431,88.3595989,17z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x3a0277cb27892585:0x225e1a9626de21a7!2m2!1d88.3621945!2d22.5908013?entry=ttu'>
                                        82D Beadon Street, Opposite Minerva Theater, Kolkata, WB 700006
                                    </a>
                                </p>
                                <p>Email:{' '}
                                    <a href="mailto:stay.friendshotel@gmail.com" className='text-hotel' target='_blank' rel="noreferrer">
                                        Stay.Friendshotel@gmail.com
                                    </a>
                                </p>
                                <p>
                                    <a href='tel:+918777209081' className='text-hotel' target='_blank' rel="noreferrer">
                                        <FaWhatsapp /> +91 8777209081 (Jayanta Ghosh)
                                    </a>
                                </p>
                                <p>
                                    <a href='tel:+917003391428' className='text-hotel' target='_blank' rel="noreferrer">
                                        <FaWhatsapp /> +91 7003391428 (Sourav Ghosh)
                                    </a>
                                </p>
                            </address>
                        </div>
                    </div>

                    <div className="col-md-3 col-sm-6">
                        <div className="footer-glass-panel">
                            <h2>Payment Accounts</h2>
                            <address>
                                <p>
                                    <FaUniversity className="footer-bank-icon" />
                                    <strong className="footer-bank-name">Friends Hotel</strong>
                                </p>
                                <p>Account: 032263700000897 <CopyButton text="032263700000897" /></p>
                                <p>IFSC: YESB0000322 <CopyButton text="YESB0000322" /></p>
                                <p className="footer-upi-gap">UPI: 8274899804@okbizaxis <CopyButton text="8274899804@okbizaxis" /></p>
                                <p>UPI: 8981330127@okbizaxis <CopyButton text="8981330127@okbizaxis" /></p>
                            </address>
                            <div className="footer-warn">
                                Kindly ensure payments are made exclusively to the account details listed on this website.
                            </div>
                            <div className="footer-danger">
                                Friendshotel.in is not liable for payments made to unverified accounts.
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3 col-sm-6">
                        <div className="footer-glass-panel">
                            <h2>Our Hotels</h2>
                            <ul>
                                {hotels.filter(h => h.bookable !== false).map(h => {
                                    const [name, loc] = h.welcome.split(',');
                                    return (
                                        <li key={h.slug} className="footer-hotel-item">
                                            <a href={`/Hotel/${h.slug}`} className='text-hotel'>
                                                {name.trim()}
                                            </a>
                                            {loc && <span className="footer-hotel-location">{loc.trim()}, Sikkim</span>}
                                        </li>
                                    );
                                })}
                            </ul>

                            <h2 className="footer-follow-heading">Follow Us</h2>
                            <div className="footer-social-links">
                                <a href='https://www.instagram.com/friendshotel.in/' target='_blank' rel="noreferrer">
                                    <FaInstagram /> Instagram
                                </a>
                                <a href='https://www.youtube.com/@Friendshotel_dot_in' target='_blank' rel="noreferrer">
                                    <FaYoutube /> YouTube
                                </a>
                                <a href='https://www.facebook.com/Friendshotelgroup' target='_blank' rel="noreferrer">
                                    <FaFacebook /> Facebook
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div className="footer-bottom mt-4">
                Developed by{' '}
                <a href='https://www.linkedin.com/in/ghsourav/' target='_blank' rel="noreferrer noopener" aria-label="Sourav Ghosh on LinkedIn">
                    <FaLinkedin /> Sourav Ghosh
                </a>
                <span className="pipe">|</span>
                <a href='https://www.instagram.com/ghsourav/' target='_blank' rel="noreferrer noopener" aria-label="Sourav Ghosh on Instagram">
                    <FaInstagram /> @ghsourav
                </a>
            </div>
        </footer>
    )
});

export default Footer
